export { }; // this file needs to be a module

String.prototype.removeAccents = function (this: string): string {
    return this.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

String.prototype.isNullOrEmpty = function (this: string): boolean {
    return !this;
}